import { render, staticRenderFns } from "./u-btn-text-tile.vue?vue&type=template&id=5cb74dfc&scoped=true&"
import script from "./u-btn-text-tile.vue?vue&type=script&lang=js&"
export * from "./u-btn-text-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb74dfc",
  null
  
)

export default component.exports